import { render } from "./ButtonsApplyCancel.vue?vue&type=template&id=67d70e25"
import script from "./ButtonsApplyCancel.vue?vue&type=script&lang=js"
export * from "./ButtonsApplyCancel.vue?vue&type=script&lang=js"
script.render = render

export default script